<template>
  <main class="terms">
    <div class="container">
      <img src="/images/logo-white.svg"
           alt="wifeed logo"
           class="logo">

      <h1 class="terms-title"
          ref="termsTitle"></h1>
      <div class="terms-content"
           ref="termsContent"></div>
    </div>
  </main>
</template>

<script>
    export default {
        components: {
       
        },

        data() {
            return {

            }
        },

        methods: {
          async loadTerms() {
            const terms = await this.$api.terms.userterms()

            this.$refs.termsContent.innerHTML = terms.content
            this.$refs.termsTitle.innerHTML = terms.title
          }
        },

        watch: {

        },

        mixins: [],

        computed: {
        },

        mounted() {
          document.getElementsByTagName('html')[0].style = 'overflow-y:scroll;'
          
          this.loadTerms()
        },

        beforeDestroy() {
        }

    }
</script>

<style  lang="scss" scoped>
@import "~@variables";

.terms {
  background: $primary;
  overflow: auto;

  .container {
    //width: 90%;

    img {
      max-width: 197px;
      margin: 50px auto;
      display: block;
    }

    .terms-title {
      color: white;
    }

    .terms-content {
      color: white;
    }
  }
}
</style>



